// @ts-nocheck
/* global css */
import React, {
  ChangeEvent, useState, useEffect,
} from 'react';
import TextareaAutosize from '@fulcrumapp/react-textarea-autosize';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

interface Props {
  disabled: boolean,
  value: { textValue: string },
  onChange(value: any): void,
  onFocusChange(isFocused: boolean): void,
}

/**
 * @deprecated this file has been replaced by material
 */
const TextField: React.FC<Props> = ({
  disabled,
  value,
  onChange,
  onFocusChange,
}: Props) => {
  const [textValue, setTextValue] = useState<string>(value.textValue || '');

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    const inputValue = event.target.value;

    setTextValue(inputValue);
    value.textValue = inputValue;
    onChange(value);
  };

  useEffect(() => {
    setTextValue(value.textValue || '');
  }, [value]);

  return (
    <TextareaAutosize
      useCacheForDOMMeasurements
      minRows={1}
      value={textValue}
      onChange={handleChange}
      onFocus={() => onFocusChange(true)}
      onBlur={() => onFocusChange(false)}
      disabled={disabled}
      className={styles.default}
    />
  );
};

const styles = cssInJS({
  default: {
    marginTop: 4,
    border: '1px solid #d9d9d9',
    padding: 4,
    width: '100%',
    borderRadius: 5,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,
    marginBottom: 0,
    overflow: 'hidden',

    '@phone': {
      border: 'none',
      padding: 6,
    },
  },
});

export default TextField;
